import { Subject } from 'rxjs';

const signedInStatusSubject = new Subject();

export const updateSignedInStatusSubject = {
  update: message => signedInStatusSubject.next(message),
  clear: () => signedInStatusSubject.next(),
  get: () => signedInStatusSubject.asObservable()
};
